(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function setGalleryImage(root, thumb) {
    if (!thumb) return;
    var image = root.querySelector('.product-gallery__image');
    if (image && thumb.dataset.galleryImage) {
      image.removeAttribute('srcset');
      image.src = thumb.dataset.galleryImage;
      image.dataset.mediaId = thumb.dataset.mediaId || '';
    }

    root.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button === thumb);
      button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
    });
  }

  function variants(root) {
    var data = root.querySelector('[data-product-variants]');
    if (!data) return [];
    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      return [];
    }
  }

  function updateVariant(root, select) {
    var variant = variants(root).find(function (entry) {
      return String(entry.id) === String(select.value);
    });
    if (!variant) return;

    var prices = root.querySelectorAll('[data-product-price]');
    var compares = root.querySelectorAll('[data-product-compare-price]');
    var submits = root.querySelectorAll('[data-product-submit]');
    var submitTexts = root.querySelectorAll('[data-product-submit-text]');
    var status = root.querySelector('[data-product-availability]');
    var currency = root.dataset.currency || 'AED';

    prices.forEach(function (price) {
      price.textContent = money(variant.price, currency);
    });
    compares.forEach(function (compare) {
      compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, currency) : '';
      compare.hidden = !(variant.compare_at_price > variant.price);
    });
    submits.forEach(function (submit) {
      submit.disabled = !variant.available;
    });
    submitTexts.forEach(function (submitText) {
      submitText.textContent = variant.available ? submitText.dataset.availableText : submitText.dataset.soldOutText;
    });
    if (status) {
      status.textContent = variant.available ? status.dataset.availableText : status.dataset.soldOutText;
      status.classList.toggle('is-sold-out', !variant.available);
    }

    if (variant.featured_media) {
      var thumb = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (thumb) setGalleryImage(root, thumb);
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function dubaiDateParts() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Dubai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      return parts.reduce(function (result, part) {
        result[part.type] = part.value;
        return result;
      }, {});
    } catch (error) {
      var now = new Date();
      return {
        year: String(now.getFullYear()),
        month: String(now.getMonth() + 1).padStart(2, '0'),
        day: String(now.getDate()).padStart(2, '0'),
        hour: String(now.getHours()).padStart(2, '0'),
        minute: String(now.getMinutes()).padStart(2, '0')
      };
    }
  }

  function addDays(dateString, days) {
    var parts = dateString.split('-').map(Number);
    var value = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2] + days));
    return value.toISOString().slice(0, 10);
  }

  function initializeDeliveryDate(root) {
    var input = root.querySelector('[data-delivery-date]');
    if (!input) return;
    var parts = dubaiDateParts();
    var today = [parts.year, parts.month, parts.day].join('-');
    var lead = Number(input.dataset.leadDays || 0);
    var cutoff = String(input.dataset.cutoff || '23:59').split(':').map(Number);
    var afterCutoff = Number(parts.hour) > cutoff[0] || (Number(parts.hour) === cutoff[0] && Number(parts.minute) >= cutoff[1]);
    input.min = addDays(today, lead + (afterCutoff ? 1 : 0));
  }

  function initialize(root) {
    if (root.dataset.productBound === 'true') return;
    root.dataset.productBound = 'true';
    initializeDeliveryDate(root);

    var select = root.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        updateVariant(root, select);
      });
    }
  }

  function initializeRecommendations(scope) {
    scope.querySelectorAll('[data-product-recommendations]').forEach(function (container) {
      if (container.dataset.loaded === 'true' || !container.dataset.url) return;
      container.dataset.loaded = 'true';

      fetch(container.dataset.url)
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations failed');
          return response.text();
        })
        .then(function (markup) {
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var replacement = parsed.querySelector('[data-product-recommendations]');
          if (replacement && replacement.innerHTML.trim()) {
            container.innerHTML = replacement.innerHTML;
          } else {
            container.hidden = true;
          }
        })
        .catch(function () {
          container.hidden = true;
        });
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      setGalleryImage(thumb.closest('[data-product-root]'), thumb);
      return;
    }

    var arrow = event.target.closest('[data-gallery-step]');
    if (arrow) {
      var root = arrow.closest('[data-product-root]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbs.length) return;
      var current = Math.max(0, thumbs.findIndex(function (entry) {
        return entry.classList.contains('is-active');
      }));
      setGalleryImage(root, thumbs[(current + Number(arrow.dataset.galleryStep) + thumbs.length) % thumbs.length]);
      return;
    }

    var zoom = event.target.closest('[data-product-zoom]');
    if (zoom) {
      var zoomRoot = zoom.closest('[data-product-root]');
      var dialog = zoomRoot.querySelector('[data-product-dialog]');
      var source = zoomRoot.querySelector('.product-gallery__image');
      var target = dialog && dialog.querySelector('img');
      if (dialog && source && target) {
        target.src = source.currentSrc || source.src;
        target.alt = source.alt;
        dialog.showModal();
      }
      return;
    }

    var dialogClose = event.target.closest('[data-product-dialog-close]');
    if (dialogClose) dialogClose.closest('dialog').close();

    var sticky = event.target.closest('[data-sticky-submit]');
    if (sticky) {
      var form = document.getElementById(sticky.getAttribute('aria-controls'));
      if (form) form.requestSubmit();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initialize);
    initializeRecommendations(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-root]').forEach(initialize);
    initializeRecommendations(event.target);
  });
})();
